'use client';

import React__default from 'react';
import { ELanguage } from '../../Utils/constants.js';
import { slugify, isMobile } from '../../Utils/helpers.js';
import JobCardMini from '../../JobCardMini/index.js';

var JobBlock = function (props) {
    var _a;
    var isHotJob = props.isHotJob, job = props.job, accessToken = props.accessToken, msUrl = props.msUrl, langCode = props.langCode, vnwBaseUrl = props.vnwBaseUrl, isFinalIndex = props.isFinalIndex, _b = props.classSelector, classSelector = _b === void 0 ? '' : _b, _c = props.enablePreviewJob, enablePreviewJob = _c === void 0 ? true : _c, userInfo = props.userInfo;
    var address = job.address, jobTitle = job.jobTitle, company = job.company, companyLogo = job.companyLogo, companyId = job.companyId, _d = job.locationsForLanguage, locationsForLanguage = _d === void 0 ? [] : _d, _e = job.url, url = _e === void 0 ? '' : _e, jobId = job.jobId, _f = job.prettySalary, prettySalary = _f === void 0 ? '' : _f, jobLevel = job.jobLevel, jobLevelVI = job.jobLevelVI, jobDescription = job.jobDescription, jobRequirement = job.jobRequirement, _g = job.isSaved, isSaved = _g === void 0 ? false : _g, _h = job.isApplied, isApplied = _h === void 0 ? false : _h, _j = job.isBlackList, isBlackList = _j === void 0 ? false : _j, isAnonymous = job.isAnonymous, _k = job.redirectTo, redirectTo = _k === void 0 ? '' : _k, jobLevelId = job.jobLevelId;
    var locationText = (locationsForLanguage === null || locationsForLanguage === void 0 ? void 0 : locationsForLanguage.join(', ')) || '';
    var companyAlias = slugify(company || '');
    var companyUrl = "/".concat(langCode === ELanguage.EN ? 'companies' : 'nha-tuyen-dung', "/").concat(companyAlias, "-c").concat(companyId);
    if (isAnonymous) {
        companyUrl = '';
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(JobCardMini, { langCode: langCode, isMobile: isMobile(), item: {
                jobTitle: jobTitle,
                jobId: jobId,
                jobUrl: url,
                companyLogo: companyLogo,
                company: company,
                companyUrl: companyUrl,
                jobLevelId: jobLevelId,
                jobLevel: jobLevel,
                jobLevelVI: jobLevelVI,
                jobLevelText: langCode === ELanguage.EN ? jobLevel : jobLevelVI,
                address: address,
                jobDescription: jobDescription,
                jobRequirement: jobRequirement,
                isSaved: isSaved,
                isApplied: isApplied,
                isBlackList: isBlackList,
                isAnonymous: isAnonymous,
                redirectTo: redirectTo,
                locationText: locationText,
                prettySalary: prettySalary,
                jobInvitation: (_a = props.job.jobInvitation) !== null && _a !== void 0 ? _a : { jobInvitationId: 0, status: 0 }
            }, displayOptions: {
                isHot: isHotJob
            }, api: {
                baseUrl: msUrl,
                accessToken: accessToken,
                appId: '',
                source: 'Find Jobs'
            }, previewJob: {
                enable: isMobile() ? false : enablePreviewJob,
                appMode: 'production',
                baseUrl: vnwBaseUrl
            }, settingJob: {
                showType: isFinalIndex ? 'top' : 'bottom'
            }, classSelector: classSelector, userInfo: userInfo, initData: props.initData })));
};

export { JobBlock as default };
//# sourceMappingURL=index.js.map
